import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tai_dab9c233f2e273c5e2a5498082090c73/node_modules/tailwind-variants/dist/index.js";
const tooltipContentVariants = tv({
  base: `
    z-50 px-3 py-1.5 w-fit bg-(--gray-text-2) text-(--gray-bg-1) animate-in fade-in-0 zoom-in-95 rounded-md text-xs text-balance
    data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95
    data-[side=bottom]:slide-in-from-top-2
      data-[side=left]:slide-in-from-right-2
       data-[side=top]:slide-in-from-bottom-2
     data-[side=right]:slide-in-from-left-2
  `,
  slots: {
    icon: "z-50 size-2.5 bg-(--gray-text-2) fill-(--gray-text-2) translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]"
  }
});
export {
  tooltipContentVariants
};
//# sourceMappingURL=index.js.map
